import { useNavigate } from "react-router-dom";
import { Button } from "@components/common/button";
import { DASHBOARD_PAGE_ROUTE } from "../utils/page-routes";
import AuthLayout from "./auth/layout";
import useTranslator from "../hooks/use-translator";

const NotFound = () => {
  const navigate = useNavigate();
  const { translate } = useTranslator();

  return (
    <AuthLayout>
      <div className="flex h-full w-full flex-col items-center justify-center gap-6 overflow-auto">
        <h3 className="text-2xl font-semibold text-white">
          {translate("Page not found")}
        </h3>{" "}
        <div className="flex w-full justify-center gap-6">
          <Button
            className="mr-8 w-20"
            variant={"secondary"}
            onClick={() => navigate(DASHBOARD_PAGE_ROUTE)}
          >
            {" "}
            {translate("Home")}{" "}
          </Button>

          <Button
            className="w-20"
            variant={"destructive"}
            onClick={() => navigate("/")}
          >
            {translate("Back")}
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default NotFound;
